<template>
  <div id="app">
    <!-- <BranchSale/> -->
     <router-view/>
  </div>
</template>

<script>
// import LoginForm from './components/LoginForm.vue'
// import BranchSale from './components/Branch/BranchSale.vue'
// import ItemPromotion from './components/Item/ItemPromotion.vue'

export default {
  name: 'App',
  components: {
    // LoginForm,
    // BranchSale,
    // ItemPromotion
  }
}
</script>

<style>
#app {
  font-family: 阿里巴巴普惠体 2.0, 阿里巴巴普惠体 2.0-55 Regular;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
* {
    margin: 0;
    padding: 0;
    list-style: none;
}
*, ::after, ::before {
    box-sizing: border-box;
}
html{
  margin: 0;
  height: 100%;
  width: 100%;
}
body{
  margin: 0;
  height: 100%;
  width: 100%;
}

</style>
